/**
 * GB API
 * API for GB Component
 *
 * The version of the OpenAPI document: -
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FieldMetaData } from './fieldMetaData';
import { HistInfoMeta } from './histInfoMeta';
import { EigentumanteilVersionIdMeta } from './eigentumanteilVersionIdMeta';
import { Bruch } from './bruch';


export interface EigentumanteilVersionDetailEntryMeta { 
    quoteAlsText?: string;
    mQuoteAlsText?: FieldMetaData;
    rechtBemerkung?: string;
    mRechtBemerkung?: FieldMetaData;
    eigentumanteilArt?: EigentumanteilVersionDetailEntryMeta.EigentumanteilArtEnum;
    mEigentumanteilArt?: FieldMetaData;
    histInfo?: HistInfoMeta;
    mHistInfo?: FieldMetaData;
    rechtBemerkungNichtOeffentlich?: string;
    mRechtBemerkungNichtOeffentlich?: FieldMetaData;
    quoteUnbekannt?: boolean;
    mQuoteUnbekannt?: FieldMetaData;
    eigentumsform?: EigentumanteilVersionDetailEntryMeta.EigentumsformEnum;
    mEigentumsform?: FieldMetaData;
    quote?: Bruch;
    mQuote?: FieldMetaData;
    id?: EigentumanteilVersionIdMeta;
    mId?: FieldMetaData;
    parzellenindex?: number;
    mParzellenindex?: FieldMetaData;
}
export namespace EigentumanteilVersionDetailEntryMeta {
    export type EigentumanteilArtEnum = 'GRUNDSTUECK' | 'PERSON' | 'HERRENLOS';
    export const EigentumanteilArtEnum = {
        GRUNDSTUECK: 'GRUNDSTUECK' as EigentumanteilArtEnum,
        PERSON: 'PERSON' as EigentumanteilArtEnum,
        HERRENLOS: 'HERRENLOS' as EigentumanteilArtEnum
    };
    export type EigentumsformEnum = 'ALLEINEIGENTUM' | 'MITEIGENTUM' | 'GESAMTEIGENTUM';
    export const EigentumsformEnum = {
        ALLEINEIGENTUM: 'ALLEINEIGENTUM' as EigentumsformEnum,
        MITEIGENTUM: 'MITEIGENTUM' as EigentumsformEnum,
        GESAMTEIGENTUM: 'GESAMTEIGENTUM' as EigentumsformEnum
    };
}


